import { render } from "./TempPasswordChangePage.vue?vue&type=template&id=7cec52d0"
import script from "./TempPasswordChangePage.vue?vue&type=script&lang=js"
export * from "./TempPasswordChangePage.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vrs/docker/web/app/front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__